<mat-dialog-content class="mat-typography">
    <span class="alet">{{data.msj}}</span>
    <div class="row">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-8" style="justify-content: start; display: flex;">
                   <span [style.color]="'#000'">
                            <!-- (click)=""> -->
                            Decargar el comprobante en PDF</span>
                </div>
                <div class="col-sm-4" style="justify-content: end; display: flex;">
                    <button  mat-raised-button
                        class="fuse-mat-button-rounded" [color]="'primary'"
                        mat-flat-button (click)="dowload('pdf')">
                            <!-- <span class="material-icons-outlined">file_download</span> -->
                            <mat-icon [svgIcon]="'file_download'"></mat-icon>
                        </button>
                </div>
            </div>
        </div>
        <!-- ####################### -->
        <div class="col-sm-12" style="margin-top: 10px;">
            <div class="row">
                <div class="col-sm-8" style="justify-content: start; display: flex;">
                   <span [style.color]="'#000'">
                            <!-- (click)=""> -->
                            Decargar el comprobante en XML</span>
                </div>
                <div class="col-sm-4" style="justify-content: end; display: flex;">
                    <button  mat-raised-button
                        class="fuse-mat-button-rounded" [color]="'primary'"
                        mat-flat-button (click)="dowload('xml')">
                            <!-- <span class="material-icons-outlined">file_download</span> -->
                            <mat-icon [svgIcon]="'file_download'"></mat-icon>
                        </button>
                </div>
            </div>
        </div>
        
            
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="0">Crear una nueva factura</button>
    <button mat-button [mat-dialog-close]="1" cdkFocusInitial>Regresar al inicio</button>
</mat-dialog-actions>


<!-- <div class="float-right">
    <button button class="flotanteDerecha accent" mat-raised-button type="button" (click)='cancelar()'>Cerrar</button>
</div> -->